import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions(debounce = false) {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    let resizeDebouncer : ReturnType<typeof setTimeout> | null = null;

    function setResizeDimensions() {
      setWindowDimensions(getWindowDimensions());
    }

    function handleResize() {
      if (debounce && resizeDebouncer) {
        clearTimeout(resizeDebouncer);
      }

      if (debounce) {
        resizeDebouncer = setTimeout(setResizeDimensions, 200);
        return;
      }

      setResizeDimensions();
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return windowDimensions;
}
